<div class="panel">
  <div class="col-12 payment-box d-flex justify-content-between align-items-center">
    <span style="font-size: 16px;">{{ title | translate }}</span>
    <img (click)="noAction(true)"
         class="cursor-pointer"
         src="/icons/close-circle.svg">
  </div>
  <div class="w-100 content-scroll overflow-y-auto overflow-x-hidden"
       style="max-height: 300px">
    <div class="row"
         style="margin: 10px 8px;">
      @if (data.chooserType === 'USER_ADDRESS') {
        @if (list.length > 0) {
          @for (userAddress of list; track $index) {
            <div (click)="onChange(userAddress)"
                 [ngClass]="{'selected-accept': userAddress?.UserAddressId === data?.UserAddress?.UserAddressId}"
                 class="payment-method">
              <div class="d-flex flex-sm-row flex-column align-items-center">
                <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
                  <mat-icon (click)="onAddressClicked(true)"
                            class="car-icon cursor-pointer">edit
                  </mat-icon>
                  <mat-icon class="car-icon">location_on</mat-icon>
                  <div>
                    <span>{{ userAddress?.Title | translate }}</span>
                    <p>{{ userAddress?.Address | translate }}
                      - {{ userAddress?.Detail | translate }}
                    </p>
                    <p>{{ 'DeliveryRecipient' | translate }}
                      : {{ userAddress?.RecipientFullName | translate }}
                      - {{ userAddress?.Phone | translate }}
                    </p>
                  </div>
                  <img
                    [src]="userAddress?.UserAddressId === data?.UserAddress?.UserAddressId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                    class="cursor-pointer">
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="w-100 d-flex flex-column align-items-center">
            <img src="/icons/empty-list.svg"
                 style="height: 200px;width: 200px;">
          </div>
        }
      } @else if (data.chooserType === 'SPACE') {
        @if (list.length > 0) {
          @for (space of list; track $index) {
            <div (click)="onChange(space)"
                 [ngClass]="{'selected-accept': space?.SpaceId === data?.Space?.SpaceId}"
                 class="payment-method">
              <div class="d-flex flex-sm-row flex-column align-items-center">
                <div class="flex-grow-1 d-flex align-items-center justify-content-between w-100">
                  <mat-icon class="car-icon">airline_seat_recline_normal</mat-icon>
                  <div>
                    <span>{{ space?.Title | translate }}</span>
                  </div>
                  <img
                    [src]="space?.SpaceId === data?.Space?.SpaceId ? '/icons/tick-circle.svg' : '/icons/circle.svg'"
                    class="cursor-pointer">
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="w-100 d-flex flex-column align-items-center">
            <img src="/icons/empty-list.svg"
                 style="height: 200px;width: 200px;">
          </div>
        }
      }
    </div>
  </div>
  <div class="d-flex gap-3"
       style="margin: 8px 10px">
    @if (data.chooserType === 'USER_ADDRESS') {
      <app-frontend-button (click)="onAddressClicked(false)"
                           [title]="'AddNewAddress' | translate"
                           class="shadow w-100 input-style"></app-frontend-button>
    }
    @if (list.length > 0) {
      <app-frontend-button (click)="onChooseClicked()"
                           [title]="'Choose' | translate"
                           class="shadow w-100 input-style"></app-frontend-button>
    }
  </div>
</div>
